import {appendQueryParam} from '@js/helpers/location';
import {routes} from "@js/helpers/routes";

export function getSearchFormParams(isDesktopForm = true) {
    const filterForm = isDesktopForm ? $('form.ranking-filters').not($('#modal-filter-form')).not($('#sort')) : $('#modal-filter-form');
    let sortMode;
    if ($('form#sort').length) {
        const [sortKey, sortValue] = new FormData($('form#sort')[0]).entries().next().value;
        sortMode = `${sortKey}=${sortValue}`
    }
    const formElement = filterForm[0];
    const formData = new FormData(formElement);
    let clearedParams = '';
    for (const [key, value] of formData.entries()) {
        if (value && value.trim() !== '') {
            clearedParams += `&${key}=${value}`;
        }
    }
    if ($('form#sort').length) {
        return `${clearedParams}&${sortMode}`;
    } else {
        return `${clearedParams}`;
    }
}

export function getRankingId() {
    return $('#rankingId').val();
}

export function refreshRankingPage(isDesktopForm = true) {
    let queryParams = getSearchFormParams(isDesktopForm);

    const $rankingTable = $('.ranking-table');
    const sortingType = $rankingTable.attr('data-sorting-type');
    if (sortingType) {
        const $column = $rankingTable.find('th.sorting-column--active');
        const sortingColumn = $column.attr('data-sorting-column');
        queryParams = appendQueryParam(queryParams, 'sort_by', sortingColumn);
        queryParams = appendQueryParam(queryParams, 'sort_type', sortingType);
    }
    refreshPageWithParams(queryParams);
}

export function refreshPageWithParams(queryParams) {
    window.location.search = queryParams;
}

export function initLockFilterYear() {
    const loginUrl = routes.public.login();
    const $tooltip = $('.lock-year');
    if ($tooltip.length) {
        $tooltip.tooltip({
            html: true,
            title: 'Доступно <a href="' + loginUrl + '">зарегистрированным</a> пользователям',
            placement: 'bottom',
            delay: {
                "show": 0,
                "hide": 3000
            }
        });
    }
}

export function initLockExceptTwoYear() {
    const plansUrl = routes.public.plansPage();
    const $tooltip = $('.two-year');
    if ($tooltip.length) {
        $tooltip.tooltip({
            html: true,
            title: 'Доступно в <a href="' + plansUrl + '">пакетах</a>',
            placement: 'bottom',
            delay: {
                "show": 0,
                "hide": 3000
            }
        });
    }
}

export function initSelectsWithLiveSearch() {
    const $selectsWithLiveSearch = $('.select-with-live-search');
    if ($selectsWithLiveSearch.length) {
        $selectsWithLiveSearch.selectpicker({
            noneResultsText: 'По запросу {0} ничего не найдено',
            noneSelectedText: 'Все',
            size: 20,
        });
    }
    $('.sidebar__filter select')
        .on('shown.bs.select' , function () {
            const $button = $(this);
            const $filterContainer = $button.closest('.sidebar__filter');
            const $selectDropdown = $filterContainer.find('.dropdown-menu.open');
            $selectDropdown.css(
                {
                    'top': '',
                    'bottom': '',
                    'max-height': ''
                }
            );
            const buttonTopOffset = $button.offset().top - $(window).scrollTop();
            const buttonHeight = $button.outerHeight();
            const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
            const spaceBelow = viewportHeight - (buttonTopOffset + buttonHeight);
            const spaceAbove = buttonTopOffset;
            const maxCeiling = 500;
            let openDirection = 'bottom';
            if (spaceBelow < maxCeiling && spaceAbove > spaceBelow) {
                openDirection = 'top';
            }
            const availableSpace = (openDirection === 'top') ? spaceAbove : spaceBelow;
            const finalMaxHeight = Math.min(availableSpace - 20, maxCeiling);
            $selectDropdown.css('max-height', finalMaxHeight + 'px');
            $selectDropdown.find('.inner.open').css('max-height', (finalMaxHeight - 100) + 'px');
            if (openDirection === 'top') {
                $selectDropdown.css({
                    'top': 'auto',
                    'bottom': '100%'
                });
                $filterContainer.addClass('dropup').removeClass('dropdown');
            } else {
                $selectDropdown.css({
                    'top': '100%',
                    'bottom': 'auto'
                });
                $filterContainer.addClass('dropdown').removeClass('dropup');
            }
        })
        .on('hidden.bs.select' , function () {
            const $button = $(this);
            const $filterContainer = $button.closest('.sidebar__filter');
            const $selectDropdown = $filterContainer.find('.dropdown-menu.open');
            $selectDropdown.css(
                {
                    'top': '',
                    'bottom': '',
                    'max-height': ''
                }
            );
            $filterContainer.removeClass('dropdown');
            $filterContainer.removeClass('dropup');
        });
}
